import { render, staticRenderFns } from "./DepositOrderAmount.vue?vue&type=template&id=868baea8&scoped=true"
import script from "./DepositOrderAmount.vue?vue&type=script&lang=js"
export * from "./DepositOrderAmount.vue?vue&type=script&lang=js"
import style0 from "./DepositOrderAmount.vue?vue&type=style&index=0&id=868baea8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_webpack@4.47.0__css-loader@0.28.11_lodash@4.17.23_vue-t_lre32xywqxiddeo252btsfuiei/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868baea8",
  null
  
)

export default component.exports